//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";

import Card from "./Card.vue"

export default {
	name: "CardList",
	components: {
		Card
	},
	data() {
		return {}
	},
	computed: {
		...mapGetters([
			"activeLocations",
			"totalLocations",
			"page",
			"isLoadingMore",
		]),
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		...mapActions([
			"sendLocationRequest"
		]),
		loadMore() {
			let currentPage;
			if (!this.page || typeof this.page != 'number') currentPage = 1;
			else currentPage = parseInt(this.page);
			this.setStateValue(['page', currentPage + 1]);
			this.sendLocationRequest([true, false]);
		},
	},
	created() {
		
	},
};
